import axios, {AxiosResponse} from 'axios/index';
import {IChatroomDialogue, INewPost} from '../chatroom/interfaces';

export const getChatroomDialoguesApi = (locale: string): Promise<AxiosResponse<IChatroomDialogue[]>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/chatroom/list`,
    {
      params: {
        language: locale
      }
    }
  );
};

export const createChatroomDialogueApi = (post: INewPost): Promise<AxiosResponse<{ value: string }>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/chatroom/add`,
    {
      name: post.name,
      text: post.text
    }
  );
};

export const addDialogueToFavoritesApi = (dialogue: IChatroomDialogue): Promise<AxiosResponse<{ value: string }>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/chatroom/favorite`,
    {
      dialogueId: dialogue.id
    }
  );
};

export const removeDialogueFromFavoritesApi = (dialogue: IChatroomDialogue): Promise<AxiosResponse<{ value: string }>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/chatroom/unfavorite`,
    {
      dialogueId: dialogue.id
    }
  );
};
